import { compose } from "recompose";
import { withPageTracker } from "../../common/withAnalytics";
import { withLSECheck } from "../../common/withLSEHandler";

export const enhance = compose(
  withPageTracker,
  withLSECheck,
);
